import { useCallback } from 'react';
import { formatMoney, type CurrencyCode } from '@keobook/shared';
import { useAuth } from './auth';

/**
 * The current client's books currency (USD/GBP/CAD/NGN), defaulting to USD when
 * no client is loaded yet. Every money amount in the authenticated app should be
 * rendered in this currency — see `useMoneyFormatter`.
 */
export function useCurrency(): CurrencyCode {
  const { currentClient } = useAuth();
  return currentClient?.currency ?? 'USD';
}

/**
 * `formatMoney` bound to the current client's currency, so pages can call
 * `fmt(cents)` without repeating the currency argument. Public/unauthenticated
 * pages (e.g. PublicInvoice) must NOT use this — they have no auth context and
 * take the currency from their own data payload instead.
 */
export function useMoneyFormatter(): (cents: number) => string {
  const currency = useCurrency();
  return useCallback((cents: number) => formatMoney(cents, currency), [currency]);
}
